import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-callc_warn",
  "use": "icon-callc_warn-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-callc_warn\"><clipPath id=\"icon-callc_warn_a\"><path d=\"m0 0h20v20h-20z\" /></clipPath><g clip-path=\"url(#icon-callc_warn_a)\" fill=\"#1a1a1a\"><path d=\"m10 19.083c-5.009 0-9.083-4.075-9.083-9.083 0-5.009 4.075-9.083 9.083-9.083s9.083 4.074 9.083 9.083c0 5.008-4.074 9.083-9.083 9.083zm0-16.667c-4.182 0-7.583 3.402-7.583 7.583s3.402 7.583 7.583 7.583 7.583-3.402 7.583-7.583-3.401-7.583-7.583-7.583z\" /><path d=\"m10 11.583c-.414 0-.75-.336-.75-.75v-5c0-.414.336-.75.75-.75s.75.336.75.75v5c0 .414-.336.75-.75.75z\" /><path d=\"m10 15c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25-1.25.56-1.25 1.25.56 1.25 1.25 1.25z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/callc_warn.svg
// module id = kGAr
// module chunks = 87